module.exports = __webpack_public_path__ + "img/udmark-light.0deebd67.png";